import Swiper from 'swiper/bundle';
import solver from 'solver-utilities';

const state = {
	swipers: [],
	set setSwipers(arr = []) {
		this.swipers = arr;
	}
};

const init = function (_swiper) {
	const lg = parseInt(solver.frontend.getCSSVariable('--lg'));
	const id = _swiper.getAttribute('data-swiper');
	const pagination = _swiper.getAttribute('data-pagination');
	const navigation = _swiper.getAttribute('data-navigation');
	const scrollbar = _swiper.getAttribute('data-scrollbar');
	const autoplay = _swiper.getAttribute('data-autoplay');
	const loop = _swiper.getAttribute('data-loop');
	const spaceBetweenSlides = _swiper.getAttribute('data-space-between-slides');
	const slidesPerViewMobile = _swiper.getAttribute('data-slides-per-view-mobile');
	const slidesPerViewDesktop = _swiper.getAttribute('data-slides-per-view-desktop');
	const effect = _swiper.getAttribute('data-effect');
  	const unique_nav = _swiper.getAttribute('data-unique-nav');

	const breakpoints = {};

	breakpoints[lg] = {
		slidesPerView: 'auto'
	};

	const config = {
		direction: 'horizontal',
		loop: false,
		slidesPerView: 'auto',
		breakpoints
	};

	if (pagination) {
		config.pagination = {
			el: '.swiper-pagination',
			clickable: true
		};
	}

	if (navigation) {
    if (unique_nav) {
      config.navigation = {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
        clickable: true,
        disabledClass: 'swiper-button-disabled'
      };
    } else {
      config.navigation = {
        nextEl: `.swiper-button-next`,
        prevEl: `.swiper-button-prev`,
        clickable: true
      };
    }
	}

	if (scrollbar) {
		config.scrollbar = {
			el: '.swiper-scrollbar'
		};
	}

	if (autoplay) {
		config.autoplay = {
			delay: 5000
		};
	}

	if (loop) {
		config.loop = true;
	}

	if (spaceBetweenSlides) {
		config.spaceBetween = parseInt(spaceBetweenSlides);
	}

	if (slidesPerViewMobile) {
    config.slidesPerView = parseInt(slidesPerViewMobile);
	}

	if (slidesPerViewDesktop) {
    config.breakpoints[lg].slidesPerView = parseInt(slidesPerViewDesktop);
	}

	if (effect && effect !== 'none') {
		config.effect = effect;
	}

	const render = new Swiper(`[data-swiper="${id}"]`, config);
};

export const swiper = function () {
	const swipers = document.querySelectorAll('[data-swiper]');
	if (!swipers || (swipers && !swipers.length)) return;

	swipers.forEach((_swiper) => {
		const slides = _swiper.querySelectorAll('.swiper-slide');
		const bounds = _swiper.getBoundingClientRect();

		if (slides.length > 1 && bounds.top > window.innerHeight) {
			state.setSwipers = [...state.swipers, _swiper];
		}
		if (slides.length > 1 && bounds.top < window.innerHeight) {
			init(_swiper);
		}
	});

	window.addEventListener('scroll', () => {
		state.swipers.forEach((_swiper, index) => {
			const bounds = _swiper.getBoundingClientRect();

			if (
				bounds.top < window.innerHeight &&
				_swiper.className.indexOf('swiper-initialized') == -1
			) {
				init(_swiper);
			}
		});
	});
};
